import { useSyncExternalStore } from "react";

import { assinarAvisosMeta, lerAvisosMeta, lerAvisosMetaVazio } from "./avisosMeta";

const semAssinatura = () => () => {};

// `ativo=false` não assina: o KDS não gera leitura nenhuma.
export function useAvisosMeta(ativo = true) {
  return useSyncExternalStore(
    ativo ? assinarAvisosMeta : semAssinatura,
    ativo ? lerAvisosMeta : lerAvisosMetaVazio,
  );
}
